__turbopack_context__.v({
  "card": "game-type-card-module__wmkbNG__card",
  "cardIn": "game-type-card-module__wmkbNG__cardIn",
  "controls": "game-type-card-module__wmkbNG__controls",
  "copy": "game-type-card-module__wmkbNG__copy",
  "customTimer": "game-type-card-module__wmkbNG__customTimer",
  "gameIcon": "game-type-card-module__wmkbNG__gameIcon",
  "noTimerButton": "game-type-card-module__wmkbNG__noTimerButton",
  "panelOpen": "game-type-card-module__wmkbNG__panelOpen",
  "playButton": "game-type-card-module__wmkbNG__playButton",
  "playIcon": "game-type-card-module__wmkbNG__playIcon",
  "timerButton": "game-type-card-module__wmkbNG__timerButton",
  "timerPanel": "game-type-card-module__wmkbNG__timerPanel",
  "timerPanelHeading": "game-type-card-module__wmkbNG__timerPanelHeading",
  "timerPresets": "game-type-card-module__wmkbNG__timerPresets",
  "wrapper": "game-type-card-module__wmkbNG__wrapper",
});
